import { render, staticRenderFns } from "./EditorMenubar.vue?vue&type=template&id=f672ee1a&"
import script from "./EditorMenubar.vue?vue&type=script&lang=ts&"
export * from "./EditorMenubar.vue?vue&type=script&lang=ts&"
import style0 from "./EditorMenubar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports